<template>
  <v-container fluid class="ProofDeliveryHistory">
    <PaginationController
      v-model="histories"
      getDataActionName="getProofDeliveryHistory"
      :historyLimit="historyLimit"
      :select="hazmatWarehouseSite"
      haveStartDate
      isStartWithoutData
      ref="paginate"
    >
      <template v-slot:dataTable>
        <v-data-table
          :headers="headers"
          :items="histories"
          hide-actions
          v-model="selectedLabels"
          item-key="orderId"
        >
          <template v-slot:items="props">
            <!-- <td class="checkbox-align-center" @click="props.item.url && props.item.status !== 'canceled' && (props.selected = !props.selected)">
              <v-layout>
                <v-checkbox
                  :disabled="!props.item.url || props.item.status === 'canceled'"
                  @click.stop="() => { props.selected = !props.selected }"
                  :value="props.selected"
                  primary
                  hide-details
                ></v-checkbox>
              </v-layout>
            </td> -->
            <td class="text-xs-center">
              {{ props.index + 1 }}
            </td>
            <td class="text-xs-left">
              <LabelDetailsWidget :shipmentLabel="props.item" :index="props.index" />
            </td>
            <td class="text-xs-left">
              <LabelAddressWidget
                :address="props.item.from"/>
            </td>
            <td class="text-xs-left">
              <LabelAddressWidget
                :address="props.item.to"/>
            </td>
            <td v-if="$store.getters.activeWarehouse" class="text-xs-left">
              {{ organizationKeyToId.get(props.item.clientKey) }}
            </td>
            <td class="text-xs-left">
              <LabelTrackingDetailWidget 
                v-if="props.item.status !== 'failed'"
                :trackingNumber="props.item.trackingNumber"
                :status="props.item.status"
                :carrier="props.item.carrier"
                :details="props.item.trackingDetails"
              />
              <div v-else>
                <p :key="messageItem.time" v-for="messageItem in props.item.messages" >
                  {{messageItem.message}}
                </p>
              </div>
            </td>
            <td class="text-xs-left">
              <v-layout v-if="props.item.carrier">
                <strong>{{ props.item.carrier }}</strong>
              </v-layout>
              <v-layout>
                {{ props.item.serviceDescription }}
              </v-layout>
            </td>
            <td class="text-xs-center">
              <v-layout row>
                <v-flex>
                  <v-btn 
                    dark 
                    flat 
                    color="primary" 
                    @click.stop="downloadFile(props.item.filePathDownloadURL)"
                  >{{ $t('export') }}</v-btn>
                </v-flex>
              </v-layout>
            </td>
          </template>
        </v-data-table>
      </template>
      <!-- <template v-slot:beforeMenu>
      </template> -->
    </PaginationController>

    <FormSubmitPopup
      ref="form"
      title="OP950"
      v-model="op950Modal.show"
      :rightMethod="exportOp950Doc"
      :rightButtonText="$t('create')"
      :rightButtonLoading="op950Modal.loading"
      :leftMethod="() => op950Modal.show = false"
      hasAlert
      medium>
      <template v-slot:input>
        <v-layout justify-space-between align-baseline>
          <v-flex md4>
            <v-menu
              v-model="showDatePick"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              :nudge-right="40"
              lazy
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="op950Modal.closeDate"
                  :label="$t('closeDate')"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="op950Modal.closeDate" @input="showDatePick = false"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex md5>
            <v-select 
              style="transform: translateY(5px)"
              :items="hazmatSitesOptions"
              v-model="op950Modal.hazmatWarehouseSite"
              :label="$t('warehouseSite')"
            />
          </v-flex>
          <v-flex md1>
          </v-flex>
        </v-layout>
      </template>
    </FormSubmitPopup>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import PaginationController from './PaginationController'
import LabelDetailsWidget from './LabelDetailsWidget'
import LabelAddressWidget from './LabelAddressWidget'
import LabelTrackingDetailWidget from './LabelTrackingDetailWidget'
import FormSubmitPopup from './FormSubmitPopup'
import { format } from 'date-fns'

export default {
  name: 'ProofDeliveryHistory',
  components: {
    PaginationController,
    LabelDetailsWidget,
    LabelAddressWidget,
    LabelTrackingDetailWidget,
    FormSubmitPopup
  },
  data () {
    return {
      selectedLabels: [],
      hazmatWarehouseSite: '',
      histories: [],
      historyLimit: 20,
      showDatePick: false,
      op950Modal: {
        show: false,
        loading: false,
        closeDate: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        hazmatWarehouseSite: ''
      }
    }
  },
  computed: {
    ...mapGetters([
      'hazmatSites',
      'activeWarehouse'
    ]),
    headers () {
      const headers = [
        { text: this.$t('details'), value: 'signature', align: 'left', sortable: false, width: '20%' },
        { text: this.$t('from'), value: 'from', align: 'left', sortable: false },
        { text: this.$t('to'), value: 'to', align: 'left', sortable: false },
        { text: this.$t('tracking/info'), value: 'trackingNumber', align: 'left', sortable: false },
        { text: this.$t('service'), value: 'shippingService', align: 'left', sortable: false },
        { text: this.$t('actions'), value: '', align: 'center', sortable: false }
      ]
      this.activeWarehouse && headers.splice(2, 0, { 
        text: this.$t('creator'), value: 'clientKey', align: 'left', sortable: false 
      })
      headers.unshift({ text: '#', value: '', align: 'center', sortable: false })
      return headers
    },
    hazmatSitesOptions () {
      return this.hazmatSites.map(site => ({
        text: site.siteName,
        value: site.key
      }))
    }
  },
  filters: {
    formatDate (date, formatter = 'yyyy/MM/dd') {
      if (!date) return ''
      return format(date, formatter)
    } 
  },
  methods: {
    downloadFile (fullPath, fileName) {
      const link = document.createElement('a')
      link.href = fullPath
      link.style.display = 'none'
      link.download = fileName
      link.target = '_blank'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    async exportOp950Doc () {
      try {
        if (this.loading) return
        this.loading = true
        const { warehouseKey, key } = this.hazmatSites.find(site => site.key === this.op950Modal.hazmatWarehouseSite) || {}
        const { data } = await this.$store.dispatch('exportOP950Document', {
          closeDate: this.op950Modal.closeDate,
          warehouseKey,
          siteKey: key
        })
        this.downloadFile(data.filePathDownloadURL)
        this.op950Modal.show = false
        this.$refs.paginate.$$initiateTable()
      } catch (err) {
        console.log(err)
        alert(err.message || this.$t('sthBroke'))
      } finally {
        this.loading = false
      }
    },
    showOp950Modal () {
      this.op950Modal.show = true
      if (
        !this.op950Modal.hazmatWarehouseSite && 
        this.hazmatSitesOptions.length
      ) {
        this.op950Modal.hazmatWarehouseSite = this.hazmatSitesOptions[0].value
      }
    }
  }
}
</script>

<style scoped>
  .fontRed {
    color: red;
  }

  .fontGreen {
    color: green;
  }
</style>



// WEBPACK FOOTER //
// src/components/ProofDeliveryHistory.vue